import React, { useState, useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import axios from "axios";

function Impressum() {
  const [content, setContent] = useState({ headerImage: "", text: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get("/api/information/public/impressum");
        setContent(response.data);
      } catch (error) {
        console.error("Error fetching impressum content:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="bg-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-600 mx-auto"></div>
          <p className="mt-4 text-gray-700">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen">
      {/* Hero Section */}
      <div className="relative w-full h-[250px] md:h-[400px] overflow-hidden">
        <img
          src={content.headerImage || "/images/Teatro_alla_Scala.jpg"}
          alt="Site Notice Hero"
          className="w-full h-full object-cover"
        />
      </div>
      {/* Breadcrumb */}
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Imprint", href: "/imprint" },
        ]}
      />
      {/* Main Content */}
      <main
        className="max-w-[1280px] mx-auto py-12 px-6 md:px-12"
        aria-label="Site Notice"
      >
        <h1 className="text-4xl md:text-3xl text-left mb-4">
          Imprint
        </h1>
        <div className="text-gray-700 text-lg leading-relaxed whitespace-pre-wrap text-left" dangerouslySetInnerHTML={{ __html: content.text || "Content coming soon..." }} />
      </main>
    </div>
  );
}

export default Impressum;
